import React, { createContext, useState, useContext } from 'react';

const AICommandContext = createContext();

export const useAICommand = () => {
    return useContext(AICommandContext);
};

export const AICommandProvider = ({ children }) => {
    const [command, setCommand] = useState(null);

    const executeCommand = (cmd) => {
        setCommand(cmd);
    };

    const clearCommand = () => {
        setCommand(null);
    };

    const value = { command, executeCommand, clearCommand };

    return (
        <AICommandContext.Provider value={value}>
            {children}
        </AICommandContext.Provider>
    );
};